<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ArrowLeft from '@/components/svg/ArrowLeft.vue';

const { t } = useI18n();

// Détecter la taille de l'écran pour mobile
const isMobile = ref(false);

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 767;
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

defineProps<{
  title: string;
  backButtonLabel?: string;
  hideBackButton?: boolean;
  subtitle?: string;
  showTitleDiv?: boolean;
  hideTitle?: boolean;
}>();

defineEmits<{
  'back-click': [];
}>();
</script>

<template>
  <div class="header-with-back-button">
    <div class="header-section" :class="{'with-indicatif': subtitle}">
      <div v-if="!hideBackButton" class="back-button-container">
        <button type="button" 
                class=""
                @click="$emit('back-click')">
          <ArrowLeft />
        </button>
      </div>
      <div v-if="!(hideTitle && isMobile)" class="title-container">
        <h1>{{ title }}</h1>
      </div>
    </div>
    <div class="indicatif-and-actions">
      <div v-if="subtitle" class="indicatif">
        <h2>{{ subtitle }}</h2>
      </div>
      <div v-if="$slots.actions" class="actions-container">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-with-back-button{
  padding-bottom: 2.8rem;
  width:100%;
}
.heading-and-toggle{
  .header-with-back-button{
    padding-bottom: 0;
  }
}
.header-section {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spc32-16);
  width: 100%;

  &.with-indicatif {
    padding-bottom: 1.6rem;
  }
}

.back-button-container {
  display: flex;
  align-items: center;
  width: 4.8rem;
  height: 4.8rem;

  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 2px solid var(--gray-200);
    border-radius: 99px;
    transition: all .5s ease;

    svg {
      height: 2.2rem;
      width: 2.2rem;
      display: block;
      fill: var(--text-primary);
      transition: all .5s ease;
    }

    &:hover {
      border-color: var(--primary-500);
      background-color: var(--primary-500);

      svg {
        fill: #ffffff;
      }
    }
  }
}

.title-container {
  width:calc(100% - 8.0rem);
  flex: 1;

  h1 {
    margin: 0;
    font-weight: 650;
    color: var(--text-primary);
    font-family: var(--inter);
    font-size: var(--fs34-22);
    text-wrap: unset;
    line-height: 1.025
  }
}

.indicatif-and-actions{
  display:flex;
  justify-content: space-between;
  align-items: center;
  gap:1.00rem;
}

.indicatif{
	h2{
		margin: 0;
    font-weight: 700;
    color: var(--text-primary);
    font-family: var(--inter);
    font-size: var(--fs20-14);
		text-wrap: unset;
    line-height: 1.125;
	}
}

@media screen and (max-width: 1024px){
  .title-container {
    width:calc(100% - 6.4rem);
  }
  
  .actions-container {
    display: none;
  }
}
</style>